import React from 'react';
import { Breadcrumb, Col, Row } from '@themesberg/react-bootstrap';

export default function PageHeader({ title, subtitle, children }) {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}>
            <Breadcrumb.Item href="#">Flowfence</Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>{title}</h4>
          {subtitle ? <p className="mb-0 text-gray">{subtitle}</p> : null}
        </div>
        {children ? <div className="btn-toolbar mb-2 mb-md-0">{children}</div> : null}
      </div>
    </>
  );
}

export function StatusBadge({ value }) {
  const map = {
    ALLOW: 'success',
    REVIEW: 'warning',
    BLOCK: 'danger',
  };
  return <span className={`badge bg-${map[value] || 'secondary'}`}>{value}</span>;
}

export function AlertMessage({ variant, message, onClose }) {
  if (!message) return null;
  return (
    <Row className="mb-3">
      <Col>
        <div className={`alert alert-${variant} alert-dismissible`} role="alert">
          {message}
          {onClose ? (
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          ) : null}
        </div>
      </Col>
    </Row>
  );
}
